import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading, EASE } from "./Reveal";

const EVENTS = [
  { n: "01", title: "Trade Shows", desc: "Draw crowds to your booth and keep them there with head-to-head racing." },
  { n: "02", title: "Dealership Events", desc: "Turn showroom visits and open houses into hands-on excitement." },
  { n: "03", title: "Product Launches", desc: "Put your brand in the driver's seat at your next big reveal." },
  { n: "04", title: "Corporate Events", desc: "Team competitions and executive entertainment, fully staffed." },
  { n: "05", title: "Conventions", desc: "High-throughput rigs built for nonstop fan traffic." },
  { n: "06", title: "Brand Activations", desc: "Custom liveries, leaderboards and lead capture built around your brand." },
];

export const Events = () => (
  <section id="events" className="relative py-20 lg:py-28 border-t border-line" data-testid="events-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        kicker="Where We Race"
        title={
          <>
            Built for <span className="text-electric">High-Stakes</span> Events
          </>
        }
        sub="Delivering unforgettable crowd engagements at major events across the country."
      />

      <div className="mt-14 border-t border-line">
        {EVENTS.map((ev, i) => (
          <motion.div
            key={ev.n}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.07, ease: EASE }}
            className="group grid grid-cols-[auto_1fr_auto] sm:grid-cols-[80px_1fr_1fr_auto] items-center gap-4 sm:gap-8 py-6 lg:py-8 border-b border-line hover:bg-panel/50 transition-colors duration-300 px-2 sm:px-4"
            data-testid={`event-row-${ev.n}`}
          >
            <span className="font-mono text-sm text-electric/70 group-hover:text-electric transition-colors">
              {ev.n}
            </span>
            <h3 className="font-display text-xl sm:text-2xl lg:text-3xl font-black uppercase tracking-tight text-slate-200 group-hover:text-slate-50 group-hover:translate-x-2 transition-all duration-300">
              {ev.title}
            </h3>
            <p className="hidden sm:block text-sm text-slate-400 max-w-sm">{ev.desc}</p>
            <ArrowUpRight className="h-5 w-5 text-slate-600 group-hover:text-electric group-hover:rotate-45 transition-all duration-300" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
